import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { http } from '@loyalup/core';
import { Layout, Button, Field, Form, Link, AuthPanel } from '@loyalup/ui';

import { ReactComponent as CircleOkIcon } from 'icons/circle-ok.svg';
import { ReactComponent as CircleXIcon } from 'icons/circle-x.svg';

import s from './ResetPassword.module.css';

const STATUSES = {
  INVALID_TOKEN: 'invalid_token',
  SUCCESS: 'success',
  INPUT: 'input',
  LOADING: 'loading',
};

const onSubmit = async (token, password, confirmation, setStatus, setErrors, t) => {
  if (password !== confirmation) {
    setErrors({ confirmation: t('поля не совпадают') });
    return;
  }

  setStatus(STATUSES.LOADING);
  setErrors({});

  const { ok, errors } = await http('POST', '/password/reset', { token, password });

  if (ok) {
    setStatus(STATUSES.SUCCESS);
  } else if (errors.token) {
    setStatus(STATUSES.INVALID_TOKEN);
  } else {
    setStatus(STATUSES.INPUT);
    setErrors(errors);
  }
};

const ResetPassword = ({ match }) => {
  const [t] = useTranslation();
  const { token } = match.params;
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(STATUSES.LOADING);
  const loading = status === STATUSES.LOADING;

  useEffect(() => {
    (async function() {
      const { ok } = await http('POST', '/password/token', { token });
      if (ok) {
        setStatus(STATUSES.INPUT);
      } else {
        setStatus(STATUSES.INVALID_TOKEN);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout center title={t('Изменение пароля')}>
      <AuthPanel>
        <div className={s.root}>
          <div className={s.header}>
            <h1>{t('Изменение пароля')}</h1>
          </div>
          {status === STATUSES.SUCCESS && (
            <div className={s.hintContainer}>
              <CircleOkIcon className={s.okIcon} />
              <p className={s.hint}>
                {t('Пароль успешно изменен. Используйте новый пароль и свой емейл для входа.')}
                <br />
                <br />
                <Link to="/login">{t('Войти')}</Link>
              </p>
            </div>
          )}
          {status === STATUSES.INVALID_TOKEN && (
            <div className={s.hintContainer}>
              <CircleXIcon className={s.xIcon} />
              <p className={s.hint}>
                {t('Эта ссылка для сброса пароля устарела. Попробуйте сбросить пароль еще раз.')}
                <br />
                <br />
                <Link to="/password/forgot">{t('Сбросить пароль')}</Link>
              </p>
            </div>
          )}
          {[STATUSES.INPUT, STATUSES.LOADING].includes(status) && (
            <p className={s.hint}>{t('Пожалуйста, введите новый пароль для вашего аккаунта.')}</p>
          )}
          {[STATUSES.INPUT, STATUSES.LOADING].includes(status) && (
            <Form onSubmit={() => onSubmit(token, password, confirmation, setStatus, setErrors, t)}>
              <Field
                label={t('Новый пароль')}
                name="password"
                type="password"
                autoFocus
                value={password}
                error={errors.password}
                disabled={loading}
                onChange={password => setPassword(password)}
              />
              <Field
                label={t('Повторите пароль')}
                name="confirmation"
                type="password"
                value={confirmation}
                error={errors.confirmation}
                disabled={loading}
                onChange={confirmation => setConfirmation(confirmation)}
              />
              <Button type="submit" fixedWidth={200} loading={loading} center>
                {t('Изменить пароль')}
              </Button>
            </Form>
          )}
        </div>
      </AuthPanel>
    </Layout>
  );
};

export default withRouter(ResetPassword);
